import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles, Avatar } from '@material-ui/core/';
import {
    Chip,
    FormLabel,
    Button, 
    Tooltip,
    IconButton,
    Dialog,
    DialogContent, 
    DialogActions 
} from '@material-ui/core/';
import FaceIcon from '@material-ui/icons/Face';
import AddIcon from '@material-ui/icons/Add';
import {
    isArrayValid
} from '../utils/Utils';

import SelectDataType from '@apricityhealth/web-common-lib/components/SelectDataType'
import SelectTupleIndex from "@apricityhealth/web-common-lib/components/SelectTupleIndex";

class EditDataTypeArray extends Component {
    constructor(props) {
        super(props);
        this.state = {
            array: JSON.parse( JSON.stringify( props.array || [] )),
            menu: null
        };
    }

    onAdd = index => e => {
        let { array } = this.state;
        array.unshift({ dataId : '', tupleIndex: 0 });
        this.setState({ array });
    }

    onSelectDataType(type, index) {
        const { array } = this.state;
        const dataId = type ? type.dataId : '';

        if ( array[index].dataId !== dataId ) {
            array[index].dataId = type ? type.dataId : '';
            this.setState({ array , menu: null});
            if (this.props.onChange)
                this.props.onChange(array)
        }
    }

    onSelectTupleIndex(tupleIndex, index) {
        console.log("onSelectTupleIndex:", tupleIndex, index);
        const { array } = this.state;
        if ( array[index].tupleIndex !== tupleIndex ) {
            array[index].tupleIndex = tupleIndex;
            this.setState({ array , menu: null});
            if (this.props.onChange)
                this.props.onChange(array)
        }
    }

    onChangeData = index => e => {
        //console.log("onChangeData:", index, e );
        const { array } = this.state;
        const { appContext } = this.props;
        const menu =
                <Dialog fullWidth={true} modal="true" open={true} PaperProps={{ style: { overflowY: 'visible' }}}>
                    <DialogContent style={{ overflowY: 'visible'}}>
                        <SelectDataType
                            appContext={appContext}
                            dataId={array[index].dataId}
                            onSelect={(type) => this.onSelectDataType(type, index)} />
                        <SelectTupleIndex
                            appContext={appContext}
                            dataId={array[index].dataId}
                            tupleIndex={array[index].tupleIndex}
                            onChange={(tupleIndex) => this.onSelectTupleIndex(tupleIndex, index)} />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" style={styles.button} onClick={this.closeMenu.bind(this)}>Cancel</Button>
                    </DialogActions>
                </Dialog>
        this.setState({ menu });
    }

    closeMenu() {
        this.setState({ menu: null });
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.array) !== JSON.stringify(this.props.array)){
            this.setState({ array: JSON.parse(JSON.stringify(this.props.array || [])) });
        }
    }


    onDelete = index => e => {
        const { array } = this.state;
        array.splice( index, 1 );
        this.setState({ array });
        if (this.props.onChange){
            this.props.onChange(array)
        }
    }

    render() {
        const { array, menu } = this.state;

        const dataChips = [];
        if (isArrayValid(array)) {
            for (let index = 0; index < array.length; index++) {
                let chipLabel = `${array[index].dataId}[${array[index].tupleIndex}]`;
                dataChips.push(
                    <Chip
                        key={index}
                        avatar={<Avatar><FaceIcon /></Avatar>}
                        label={chipLabel}
                        onClick={this.onChangeData(index)}
                        onDelete={this.onDelete(index)}
                    />);

            }
        }

        const label = <FormLabel>{this.props.label || "Edit Data Types"}</FormLabel>;
        return (<div >
            <div style={{  marginTop: '5px' }} />
            {this.props.tip && <Tooltip title={this.props.tip}>{label}</Tooltip>}
            {!this.props.tip && label}
            <div style={{ marginTop: '5px' }} />
            <Tooltip title="Add" style={{ marginRight: '10px' }}>
                <IconButton aria-label="Add" onClick={this.onAdd()}>
                    <AddIcon />
                </IconButton>
            </Tooltip>
            {dataChips}
            {menu}
        </div>
        )
    }
}

const styles = {
    div: {
        margin: 10
    }
};

EditDataTypeArray.propTypes = {
    children: PropTypes.node,
    classes: PropTypes.object.isRequired
};


export default withStyles(styles)(EditDataTypeArray);
